import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import {
  fetchDocumentCategoriesThunk,
  type DocumentCategory,
} from "./documentOperations";
import type { RootState } from "@/store/store";

// Redux Toolkit v2: selectId is no longer needed if entities have an 'id' field
const entityAdapter = createEntityAdapter<DocumentCategory>();

type DocumentCategoriesState = ReturnType<
  typeof entityAdapter.getInitialState
> & {
  isLoading: boolean;
};

const initialState: DocumentCategoriesState = {
  isLoading: false,
  ...entityAdapter.getInitialState(),
};

const slice = createSlice({
  name: "documentCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDocumentCategoriesThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDocumentCategoriesThunk.fulfilled, (state, action) => {
      entityAdapter.setAll(state, action.payload);
      state.isLoading = false;
    });
    builder.addCase(fetchDocumentCategoriesThunk.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const documentCategorySelectors = entityAdapter.getSelectors(
  (state: RootState) => state.documents.documentCategories,
);

export const reducer = slice.reducer;
